import { handleActions } from 'redux-actions'
import { createSelector } from 'reselect'

import api from 'src/services/@core/API'

import { companySelector } from 'src/store/modules/company/selectors'
import { setCompanyHierarchy } from 'src/store/modules/actionCreators'

/* --------- reducer --------- */
const initialState = []

export default handleActions(
  {
    [setCompanyHierarchy](state, { payload = [] }) {
      return [...payload]
    }
  },
  initialState
)

/* --------- thunks --------- */
export const getCompanyStructure = (query) => (dispatch) =>
  api.getCompanyStructure(query).then(
    (hierarchy) => dispatch(setCompanyHierarchy(hierarchy.items)),
    (err) => Promise.reject(err)
  )

/* --------- selectors --------- */
export const companyHierarchySelector = createSelector(
  companySelector,
  ({ structure }) => structure
)
